export default "__VITE_ASSET__71284b67__"